import { put, takeEvery, takeLatest, select } from 'redux-saga/effects';

import { 
  getCategoryGroupsAction,
  getCategoryGroupsSuccessAction,
} from 'companion-app-components/flux/category-groups/categoryGroupsActions';
import { resourceStoreTypes, resourceSagaUtils } from 'companion-app-components/flux/core';
import { categoriesSelectors } from 'companion-app-components/flux/categories';
import { authSelectors } from 'companion-app-components/flux/auth';
import { getCategoryGroupLists } from 'companion-app-components/flux/category-group-lists/categoryGroupListsSelectors';
import { getLastSyncDate, getCategoryGroupsByIdRaw } from 'companion-app-components/flux/category-groups/categoryGroupsSelectors';

import * as categoryGroupsActions from 'data/categoryGroups/categoryGroupsActions';
import { createCategoryGroupListsSuccessAction } from 'data/categoryGroupLists/categoryGroupListsActions';
import { getCreateCategoryGroupsPayload } from 'data/categoryGroups/categoryGroupsUtils';

const mkResourceConfig = (props) => resourceStoreTypes.mkQcsSyncResourceConfig({
  resourceName: 'categoryGroups',
  resourceBaseUrl: '/category-groups',
  getLastSyncDate,
  ...props,
});

export function* createCategoryGroupActionWatcher() {
  const config = mkResourceConfig({
    successAction: categoryGroupsActions.createCategoryGroupsSuccessAction,
    failureAction: categoryGroupsActions.createCategoryGroupsFailureAction,
  });
  yield takeEvery(categoryGroupsActions.createCategoryGroupsAction.type, resourceSagaUtils.qcsSyncUpdateResources, config);
}

function* createCategoryGroups() {
  const catGroups = yield select(getCategoryGroupsByIdRaw);
  const isWebFirstDataset = yield select(authSelectors.getIsWebfirstDataset);
  if (catGroups?.size === 0 && isWebFirstDataset) {
    const categoryGroupListsFetched = yield select(getCategoryGroupLists);
    const categoryGroupListId = categoryGroupListsFetched?.first()?.id;
    if (categoryGroupListId) {
      const allIncomeCategories = yield select(categoriesSelectors.getIncomeCOAIds);
      const allExpenseCategories = yield select(categoriesSelectors.getExpenseCOAIds);
      const payload = getCreateCategoryGroupsPayload(allIncomeCategories, allExpenseCategories, categoryGroupListId);
      yield put(categoryGroupsActions.createCategoryGroupsAction(payload));
    }
  }
}

export function* createCategoryGroupListsSuccessActionWater() {
  yield takeEvery([createCategoryGroupListsSuccessAction, getCategoryGroupsSuccessAction], 
    createCategoryGroups);
}

function* triggerGetCategoryGroups() {
  yield put(getCategoryGroupsAction());
}

export function* createCategoryGroupsSuccessActionWatcher() {
  yield takeLatest(categoryGroupsActions.createCategoryGroupsSuccessAction, triggerGetCategoryGroups);
}

export default [
  createCategoryGroupActionWatcher,
  createCategoryGroupListsSuccessActionWater,
  createCategoryGroupsSuccessActionWatcher,
];
